import React from "react";
import { connect } from "react-redux";
import { getHubChildStruct } from "../../helpers/axios/Get";
import {
  getSelectedModel,
  getSelectedModelArray,
  properties,
  updateSelectedSchedule,
} from "../../helpers/actions/Action";
import {
  FETCH_SELECTED_PROJECT_ISSUES_DATA_PENDING,
  FETCH_SELECTED_PROJECT_ISSUES_DATA_ERROR,
  FETCH_SELECTED_PROJECT_ISSUES_DATA_SUCCESS,
  ISSUE_URL,
} from "../../helpers/constants/Constants";
import store from "../../helpers/store/Store";
import { requestData } from "../../helpers/axios/Get";

const axios = require("axios");

class ProjectBrowser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentViewed: null,
      currentSelected: null,
      selectedArray: [],
      maxArrayLength: 4,
      clicked: 0,
      mobileWidth: false,
      tabletWidth: false,
      maxViewers: 1,
    };
  }

  renderSubMenu = (children, expanded) => {
    if (expanded && children && children.length > 0) {
      return <ul>{this.renderMenuItems(children)}</ul>;
    }
    return null;
  };

  nameShortening = (text) => {
    let maxLength = this.props.settings.maxProjectBrowserNameLength;
    let shortendName =
      text.length >= maxLength ? text.substring(0, maxLength) + "..." : text;
    return <span> {shortendName} </span>;
  };

  renderMenuItems = (items) =>
    items.map((item, i) => {
      const {
        text,
        children,
        expanded,
        childArray,
        type,
        fileType,
        active,
        fileName,
        hrefbim360,
      } = item;
      if (children) {
        let isInBlackList = this.props.blackList.filter((obj) => {
          return obj.type.toLowerCase() === text.toLowerCase();
        });
        if (!isInBlackList[0]) {
          return (
            <li
              key={i}
              aria-expanded={expanded ? true : false}
              className={`${
                item.loading ? "data-loading" : "data-not-loading"
              }`}
            >
              <button
                type="button"
                className="btn icon icon-folder has-children"
                onClick={(e) => this.updateState(item)}
                title={text}
                data-toggle="tooltip"
                data-placement="right"
              >
                <div className="sk-circle">
                  <div className="sk-circle1 sk-child" />
                  <div className="sk-circle2 sk-child" />
                  <div className="sk-circle3 sk-child" />
                  <div className="sk-circle4 sk-child" />
                  <div className="sk-circle5 sk-child" />
                  <div className="sk-circle6 sk-child" />
                  <div className="sk-circle7 sk-child" />
                  <div className="sk-circle8 sk-child" />
                  <div className="sk-circle9 sk-child" />
                  <div className="sk-circle10 sk-child" />
                  <div className="sk-circle11 sk-child" />
                  <div className="sk-circle12 sk-child" />
                </div>
                {this.nameShortening(text)}
              </button>
              {this.renderSubMenu(childArray, expanded)}
            </li>
          );
        }
      } else if (type === "version" || type === "item") {

        let isInList = this.props.whiteList.filter((obj) => {
          return obj.type === fileType;
        });
        if (isInList[0]) {
          return (
            <li key={i}>
              <button
                type="button"
                className={`btn icon icon-file ${
                  fileType ? "icon-file-" + fileType : "icon-file"
                } ${active ? "active" : "non-active"} `}
                onClick={(e) => this.clickHandler(e, item, true)}
                title={fileName}
                data-toggle="tooltip"
                data-placement="right"
              >
                {this.nameShortening(fileName)}
              </button>
            </li>
          );
        } else {
          return (
            <li key={i}>
              <a
                className={`btn icon icon-file ${
                  fileType ? "icon-file-" + fileType : "icon-file"
                } ${active ? "active" : "non-active"} `}
                href={hrefbim360}
                title={fileName}
                data-toggle="tooltip"
                data-placement="right"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => this.clickedItem(false, item, false)}
              >
                {this.nameShortening(fileName)}
              </a>
            </li>
          );
        }
      } else {
        return (
          <li key={i} aria-expanded="false" className="data-not-loading">
            <button
              type="button"
              className="btn icon icon-folder has-no-children"
              title={text}
              data-toggle="tooltip"
              data-placement="right"
            >
              {this.nameShortening(text)}
            </button>
          </li>
        );
      }
      return null;
    });

  updateState = (item) => {
    let self = this;
    //let check = item.expanded === true ? true : false
    if (item.childArray && item.expanded) {
      item.expanded = !item.expanded;
      self.setState(self.state);
    } else {
      item.loading = true;
      self.setState(self.state);
      console.log("item.id in updatestate =", item.id);
      axios.all([getHubChildStruct(item.id, { withCredentials: true })]).then(
        axios.spread(function (items) {
          item.loading = false;
          if (items.data.length > 0) {
            item.childArray = items.data;
            item.expanded = !item.expanded;
            self.setState(self.state);
          } else {
            alert("No Data in " + item.text);
            item.loading = false;
            self.setState({});
          }
        })
      );
    }
  };

  // Controlling if doubleclick
  clickHandler = (e, item, noLink) => {
    let self = this;
    self.setState({
      clicked: self.state.clicked + 1,
    });
    window.setTimeout(() => {
      if (self.state.clicked >= 2) {
        self.clickedItem(true, item, noLink);
        self.setState({
          clicked: 0,
        });
      } else if (self.state.clicked === 1) {
        self.clickedItem(false, item, noLink);
        self.setState({
          clicked: 0,
        });
      }
    }, 300);
  };

  clickedItem = (doubleclick, item, noLink) => {
    console.log("item =",item)
    store.dispatch(updateSelectedSchedule(""));
    // console.log("item =", item);
    // console.log("props =", this.props);
    item.active = true;
    if (this.state.currentSelected !== null) {
      this.setState({
        currentSelected: {
          ...this.state.currentSelected,
          active: false,
        },
      });
    }
    if (noLink) {
      this.props.selectedModel(item);
      if (
        this.props.modelArray.length < this.state.maxViewers &&
        this.props.allowAdditionalTabs === true
      ) {
        let selected = this.props.modelArray.filter((obj) => {
          return obj.id === item.id;
        });
    console.log("selected =",selected)

        if (selected.length === 0) {
          let array = Array.from(this.props.modelArray);
          let int = array.findIndex((obj) => obj.selected === true);
          if (doubleclick) {
            array[int] = {
              id: item.id,
              name: item.fileName,
              number: Math.random(),
              selected: true,
            };
          } else {
            array = array.map((obj) => {
              obj.selected = false;
              return obj;
            });
            array.push({
              id: item.id,
              name: item.fileName,
              number: Math.random(),
              selected: true,
            });
          }
          console.log("clickedItem - SelectedModelArray",array)
          store.dispatch(getSelectedModelArray(array));
        }
      } else {
        alert(
          "Please note you have reached the maximum number of tabs allowed, this is limited to 1 on mobile devices and dependant on the size of 3D model you are viewing on PC."
        );
      }
      store.dispatch(properties({ id: item.id, data: [] }));
    }
    this.setState({
      currentViewed: item.id,
      currentSelected: item,
    });
  };

  componentDidMount() {
    if (window.screen.width <= this.props.settings.mobileWidth) {
      this.setState({
        isMobile: true,
        maxViewers: 1,
      });
    } else if (window.screen.width <= this.props.settings.tabletWidth) {
      this.setState({
        isTablet: true,
      });
    } else {
      if (this.props.settings.maxViewers !== undefined) {
        this.setState({
          maxViewers: this.props.settings.maxViewers,
        });
      }
    }
  }

  render() {
    return (
      <nav id="theBrowser">
        <ul>{this.renderMenuItems(this.props.data)}</ul>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.requestSelectedProjectDataReducer.data,
  selected: state.getSelectedProjectReducer.data,
  selectedModel: state.getSelectedModelReducer.data,
  whiteList: state.requestFileWhiteListReducer.data,
  blackList: state.requestFolderBlackListReducer.data,
  modelArray: state.getModelArrayReducer.data,
  settings: state.requestGeneralSettingsReducer.data,
  allowAdditionalTabs: state.metaPropReducer.allowAdditionalTabs,
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectedModel: (selected) => {
      dispatch(getSelectedModel(selected));
    },
    onrequestIssuesDataReducer: (id, config, callback) =>
      dispatch(
        requestData(
          ISSUE_URL + id,
          {
            pending: FETCH_SELECTED_PROJECT_ISSUES_DATA_PENDING,
            error: FETCH_SELECTED_PROJECT_ISSUES_DATA_ERROR,
            success: FETCH_SELECTED_PROJECT_ISSUES_DATA_SUCCESS,
          },
          config,
          callback
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectBrowser);
